const AUTH_KEYS = ["authTempToken", "authToken", "User", "userRole"];

const getFromStorage = (storage, key) => {
  try {
    return storage?.getItem(key) || "";
  } catch (error) {
    return "";
  }
};

const setInStorage = (storage, key, value) => {
  try {
    if (value == null || value === "") {
      storage?.removeItem(key);
      return;
    }

    storage?.setItem(key, value);
  } catch (error) {
    // Ignore storage synchronization failures.
  }
};

export const syncAuthStorage = () => {
  if (typeof window === "undefined") {
    return;
  }

  AUTH_KEYS.forEach((key) => {
    const sessionValue = getFromStorage(window.sessionStorage, key);
    const localValue = getFromStorage(window.localStorage, key);

    if (!sessionValue && localValue) {
      setInStorage(window.sessionStorage, key, localValue);
    }

    if (!localValue && sessionValue) {
      setInStorage(window.localStorage, key, sessionValue);
    }
  });
};

export const getAuthToken = () => {
  syncAuthStorage();

  if (typeof window === "undefined") {
    return "";
  }

  return (
    getFromStorage(window.sessionStorage, "authToken") ||
    getFromStorage(window.localStorage, "authToken")
  );
};

export const getAuthTempToken = () => {
  syncAuthStorage();

  if (typeof window === "undefined") {
    return "";
  }

  return (
    getFromStorage(window.sessionStorage, "authTempToken") ||
    getFromStorage(window.localStorage, "authTempToken")
  );
};

export const getStoredUser = () => {
  syncAuthStorage();

  if (typeof window === "undefined") {
    return "";
  }

  return getFromStorage(window.sessionStorage, "User") || getFromStorage(window.localStorage, "User");
};

export const getParsedStoredUser = () => {
  const rawUser = getStoredUser();
  if (!rawUser) {
    return null;
  }

  try {
    return JSON.parse(rawUser);
  } catch (error) {
    return null;
  }
};

export const clearAuthStorage = () => {
  if (typeof window === "undefined") {
    return;
  }

  AUTH_KEYS.forEach((key) => {
    setInStorage(window.sessionStorage, key, "");
    setInStorage(window.localStorage, key, "");
  });
};
